export const OTHER_TOOLS_OPTION_IDS = {
  CPANEL: 'cpanel',
  FTP: 'ftp',
  SOFTACULOUS: 'softaculous',
};
